// @flow

import _ from 'lodash';

export type ReactComponentParams<T = {}> = {
	name: string,
	eventEmitterName: string,
	entrypoints: string,
	model: T,
	queryParams?: string
}
export class ReactComponentModel {
	constructor (params: {props: ReactComponentParams}) {
		params = _.defaultsDeep({}, params.props, {
			entrypoints: undefined,
			eventEmitterName: undefined,
			model: undefined,
			name: undefined,
			queryParams: undefined,
		});

		this._params = params;
	}
}
